var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "d-flex justify-content-center py-2" },
        [
          _c("OnlyView", {
            attrs: { JobCard: _vm.JobCard },
            on: { onchange: _vm.bomChanged, existingPO: _vm.existingPO },
          }),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "d-flex justify-content-center py-2" },
        [
          _c("AddBOM", {
            attrs: { JobCard: _vm.JobCard },
            on: { onchange: _vm.addBomChanged, newPO: _vm.newPO },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            {
              staticClass: "mt-0 mt-md-2 mr-3",
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.createPurchase()
                },
              },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-25",
                attrs: { icon: "XIcon" },
              }),
              _c("span", [_vm._v("Create PO")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }